// extracted by mini-css-extract-plugin
export default {"article":"GroupedArticles_article__Cg1DX","time":"GroupedArticles_time__m2kto","timeOffset":"GroupedArticles_timeOffset__Zz23X","card":"GroupedArticles_card__o2ZJo"};